var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.useAsBackground)?_c('img',{attrs:{"src":_vm.imageSource,"alt":_vm.description,"width":_vm.width,"height":_vm.height}}):_c('div',[_c('img',{attrs:{"src":_vm.imageSource,"alt":_vm.description}})])}
var staticRenderFns = []

export { render, staticRenderFns }